import { appMethod as app } from '@utils/app';

import './RequestStatus.less';

// 加载loading
const RequestLoading = () => (
  <div className="loading-wrap">
    <div className="loading-view">
      <div className="loading-dot1"></div>
      <div className="loading-dot2"></div>
    </div>
  </div>
)

// 加载没有数据
const RequestNone = (props) => {
  const { data } = props.data;
  return (
    <div className="request-none">
      <img src="http://cdn.jisuapp.cn/static/webapp/images/request-none.png"/>
      <div>{data || '暂无数据'}</div>
    </div>
  )
}

// 加载失败
const RequestFail = (props) => {
  const { compindex, refreshEvent } = props.data;
  return (
    <div className="request-fail">
      <div>数据加载失败~ </div>
      <button className="request-refresh-btn" data-compindex={compindex} bindtap={app[refreshEvent]} >刷新重试</button>
    </div>
  )
}

// 加载完所有数据
const RequestAll = () => (
  <div className="request-all">没有更多了</div>
)

export function RequestStatus(props) {
  // 状态类型
  const is = props.is;
  // 是否为横版
  const hor = props.hor;
  const templates = {
    // 加载loading
    'requestLoading': (props) =>  <RequestLoading {...props}></RequestLoading>,
    // 加载没有数据
    'requestNone': (props) =>  <RequestNone {...props}></RequestNone>,
    // 加载失败
    'requestFail': (props) =>  <RequestFail {...props}></RequestFail>,
    // 加载完所有数据
    'requestAll': (props) =>  <RequestAll {...props}></RequestAll>,
  }
  if (!templates[is]) {
    return null;
  }
  return (
    <div className={`common request-status ${hor && 'hor-request-status'}`}>
      {templates[is](props)}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/common/request-status/RequestStatus.jsx